import { render, staticRenderFns } from "./VEmptyState.vue?vue&type=template&id=7dd25133"
import script from "./VEmptyState.vue?vue&type=script&lang=js"
export * from "./VEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd25133')) {
      api.createRecord('7dd25133', component.options)
    } else {
      api.reload('7dd25133', component.options)
    }
    module.hot.accept("./VEmptyState.vue?vue&type=template&id=7dd25133", function () {
      api.rerender('7dd25133', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commons/VEmptyState.vue"
export default component.exports